import { observer } from 'mobx-react-lite';
import React, { Fragment, useState } from 'react'
import { Grid, Header, Icon, Loader, Segment } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/Store';
//import { history } from '../../../..';
// @ts-ignore - InfiniteScroll is a class component compatible with React 18
import InfiniteScroll from 'react-infinite-scroller';
import PurchaseOrderList from './PurchaseOrderList';
import PurchaseOrderListPlaceholder from './PurchaseOrderListPlaceholder';

const PurchaseOrderSearchResults = () => {
    const { poStore, searchStore } = useStore();
    const { loadProgressivePurchaseOrders, loadingSearch, purchaseorders } = poStore;
    const { totalPages, currentPageNo, setPageNo } = searchStore;

    const [loadingNext, setLoadingNext] = useState(false);


    const handleScroll = async () => {
        setLoadingNext(true);
        setPageNo(currentPageNo + 1);
        loadProgressivePurchaseOrders().then(async () => {
            await new Promise(r => setTimeout(r, 5000));
            setLoadingNext(false)
        });
    }


    if (loadingSearch) return <PurchaseOrderListPlaceholder />

    return (
        <Fragment>
            {purchaseorders.length <= 0 ? (
                <Grid>
                    <Grid.Column width={16}>
                        <Segment placeholder>
                            <Header icon>
                                <Icon name='asl' />
                                Darn it!, No documents found for your search.
                            </Header>
                        </Segment>
                    </Grid.Column>
                </Grid>

            ) : (
                <Grid>
                    <Grid.Column width={16}>
                        {/* @ts-ignore */}
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={handleScroll}
                            hasMore={!loadingSearch && currentPageNo + 1 <= totalPages}
                            initialLoad={false}>
                            <PurchaseOrderList />
                        </InfiniteScroll>
                    </Grid.Column>
                    <Grid.Column width={16}>
                        <Loader active={loadingNext} />
                    </Grid.Column>
                </Grid >

            )}

        </Fragment >
    )
}

export default observer(PurchaseOrderSearchResults)
